import * as React from "react";
import { SVGProps } from "react";

const MultiCollateralDai = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 444 444"
    {...props}
  >
    <g fillRule="nonzero">
      <path
        fill="#F5AC37"
        d="M222.22 0c122.74 0 222.22 99.5 222.22 222.22 0 122.74-99.48 222.22-222.22 222.22C99.5 444.44 0 344.95 0 222.22 0 99.5 99.5 0 222.22 0z"
      />
      <path
        fill="#FEFEFD"
        d="M230.41 237.91h84.44c1.8 0 2.65 0 2.78-2.36.69-8.59.69-17.23 0-25.83 0-1.67-.83-2.36-2.64-2.36H146.94c-2.08 0-2.64.69-2.64 2.64v24.72c0 3.19 0 3.19 3.33 3.19h82.78zm77.79-59.44c.24-.63.24-1.32 0-1.94-1.41-3.07-3.08-6-5.02-8.75-2.92-4.7-6.36-9.03-10.28-12.92a34.076 34.076 0 0 0-6.39-6.25 99.833 99.833 0 0 0-41.67-21.11c-7.75-1.74-15.67-2.57-23.61-2.5h-74.58c-2.08 0-2.36.83-2.36 2.64v49.3c0 2.08 0 2.64 2.64 2.64H307.2s1.39-.28 1.67-1.11h-.68zm0 88.33c-2.36-.26-4.74-.26-7.1 0H147.08c-2.08 0-2.78 0-2.78 2.78v48.2c0 2.22 0 2.78 2.78 2.78h71.11c3.4.26 6.8.02 10.13-.69 10.32-.74 20.47-2.98 30.15-6.67 3.52-1.22 6.92-2.81 10.13-4.72h.97a90.23 90.23 0 0 0 38.75-39.01s.97-2.1-.12-2.65zm-191.81 78.75v-76.8c0-1.81 0-2.08-2.22-2.08H84.03c-1.67 0-2.36 0-2.36-2.22v-26.39h32.22c1.8 0 2.5 0 2.5-2.36v-26.11c0-1.67 0-2.08-2.22-2.08H84.03c-1.67 0-2.36 0-2.36-2.22v-24.44c0-1.53 0-1.94 2.22-1.94h29.86c2.08 0 2.64 0 2.64-2.64v-74.86c0-2.22 0-2.78 2.78-2.78h104.16c7.56.3 15.07 1.13 22.5 2.5 15.31 2.83 30.02 8.3 43.47 16.11 8.92 5.25 17.13 11.59 24.44 18.89 5.5 5.71 10.46 11.89 14.86 18.47 4.37 6.67 8 13.8 10.85 21.25a3.617 3.617 0 0 0 4.15 2.92h24.86c3.19 0 3.19 0 3.33 3.06v22.78c0 2.22-.83 2.78-3.06 2.78h-19.17c-1.94 0-2.5 0-2.36 2.5.76 8.46.76 16.95 0 25.41 0 2.36 0 2.64 2.65 2.64h21.93c.97 1.25 0 2.5 0 3.76.14 1.61.14 3.24 0 4.85v16.81c0 2.36-.69 3.06-2.78 3.06h-26.25c-1.83-.35-3.61.82-4.03 2.64a111.06 111.06 0 0 1-29.17 42.5c-4.72 4.25-9.68 8.25-14.86 11.94-5.56 3.2-10.97 6.53-16.67 9.17-10.49 4.72-21.49 8.2-32.78 10.41a170.893 170.893 0 0 1-32.5 2.64h-96.39v-.14z"
      />
    </g>
  </svg>
);

export default MultiCollateralDai;
